module.exports = __webpack_public_path__ + "media/images/new/trail_maps-d3409e5be6b0d92511c2ee843783bc04.jpg";